import { render, staticRenderFns } from "./SuggestionForm.vue?vue&type=template&id=59a1444e"
import script from "./SuggestionForm.vue?vue&type=script&lang=js"
export * from "./SuggestionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports